import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import Decimal from 'decimal.js'
import { formatAmount } from '@/utils/money.ts'

dayjs.extend(utc)

export function formatMoney(value: string) {
  const [whole, fraction] = formatAmount(value).split('.')
  return `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${fraction}`
}
export function growth(current: string | number, previous: string | number) {
  const base = new Decimal(previous)
  const value = new Decimal(current)
  if (base.isZero()) {
    return value.isZero() ? '持平' : '无法计算'
  }
  if (base.isNegative()) {
    return '不适用（对比期为负）'
  }
  const change = value.sub(base).div(base).mul(100)
  return `${change.gt(0) ? '+' : ''}${change.toFixed(1)}%`
}
export function currentMonth() {
  return dayjs().utcOffset(8).format('YYYY-MM')
}
export function snapshotTime(value: string) {
  return dayjs(value).utcOffset(8).format('MM/DD HH:mm')
}
